import { render, staticRenderFns } from "./AvaliacaoView.vue?vue&type=template&id=680f81f9"
import script from "./AvaliacaoView.vue?vue&type=script&lang=js"
export * from "./AvaliacaoView.vue?vue&type=script&lang=js"
import style0 from "./AvaliacaoView.vue?vue&type=style&index=0&id=680f81f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports